<div>
  <div class="flex items-center m-b-10">
    <span><b>Employment Details</b></span>
    <mat-icon *ngIf="hasPermissions"
              class="add-icon"
              color="primary"
              matTooltip="Add employment detail"
              (click)="onAddEmployment()">add
    </mat-icon>
  </div>

  <div *ngIf="employmentDetails && employmentDetails.length > 0">
    <ul>
      <li *ngFor="let employment of employmentDetails" class="flex items-center">
        <span class="m-r-10">{{getEmploymentDetailsString(employment)}}</span>
        <ng-container *ngIf="hasPermissions">
          <mat-icon class="edit-icon" color="primary"
                    matTooltip="Edit employment detail"
                    (click)="onEditEmployment(employment)">edit
          </mat-icon>
          <mat-icon class="edit-icon" color="primary"
                    matTooltip="Delete employment detail"
                    (click)="onDeleteEmployment(employment)">delete
          </mat-icon>
        </ng-container>
      </li>
    </ul>
  </div>
  <div *ngIf="!employmentDetails || employmentDetails.length === 0">
    <p>No employment details found.</p>
  </div>
</div>
